import styled from 'styled-components';

import { breakpoints } from '@/shared/styles';

export const VerticalSeparator = styled.div`
  width: 70%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  user-select: none;
  position: absolute;
  top: 0;
  right: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  transform: translateY(50%);

  @media (max-width: ${breakpoints.mobileLG}px) {
    transform: translateY(167px);
    width: 100%;
  }
`;
